import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams
import { fetchForm, submitForm } from "../api/forms";
import Form from "../components/Form/Form";

const FormPage = () => {
    const { formId } = useParams(); // Extract formId from route params
    const [form, setForm] = useState(null);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    useEffect(() => {
        const loadForm = async () => {
            try {
                const fetchedForm = await fetchForm(formId); // Use formId to fetch form
                setForm(fetchedForm);
            } catch (err) {
                setError("Failed to load the form.");
            }
        };

        if (formId) {
            loadForm();
        } else {
            setError("Invalid form ID.");
        }
    }, [formId]);

    const handleSubmit = async (formData) => {
        try {
            await submitForm(form.id, formData);
            setSuccessMessage("Form submitted successfully!");
        } catch (err) {
            setError("Failed to submit the form.");
        }
    };

    if (error) return <p>{error}</p>;
    if (!form) return <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500"></div>;

    return (
        <div>
            <Form
                fields={form.fields}
                onSubmit={handleSubmit}
                formTitle={form.title}
            />
            {successMessage && <p>{successMessage}</p>}
        </div>
    );
};

export default FormPage;
